import {makeAutoObservable} from 'mobx'
import {DataObjectId} from 'yougile-model'
import {ChatUtils} from '@extensions/chat-utils'

interface State {
  openedChatTaskId?: DataObjectId
}

class ChatStore {
  state: State = {}

  constructor() {
    makeAutoObservable(this)
    ChatUtils.addChatChangeListener(() => {
      this.updateOpenedChatTaskId()
    })
  }

  isOpened(id: DataObjectId): boolean {
    return this.state.openedChatTaskId === id
  }

  updateOpenedChatTaskId(): void {
    this.state.openedChatTaskId = ChatUtils.getOpenedChatHub()?.id
  }
}

export const chatStore = new ChatStore()
